export var StaffInfo;
(function (StaffInfo) {
    StaffInfo[StaffInfo["show"] = 1] = "show";
    StaffInfo[StaffInfo["hide"] = 0] = "hide";
})(StaffInfo || (StaffInfo = {}));
export var CarrierType;
(function (CarrierType) {
    CarrierType[CarrierType["dianxin"] = 3] = "dianxin";
    CarrierType[CarrierType["liantong"] = 2] = "liantong";
})(CarrierType || (CarrierType = {}));
export var MenuItemType;
(function (MenuItemType) {
    MenuItemType[MenuItemType["phone"] = 1] = "phone";
    MenuItemType[MenuItemType["consult"] = 2] = "consult";
    MenuItemType[MenuItemType["form"] = 3] = "form";
    MenuItemType[MenuItemType["goWeb"] = 4] = "goWeb";
})(MenuItemType || (MenuItemType = {}));
export var TransformType;
(function (TransformType) {
    TransformType[TransformType["phone"] = 1] = "phone";
    TransformType[TransformType["form"] = 2] = "form";
    TransformType[TransformType["consult"] = 3] = "consult";
})(TransformType || (TransformType = {}));
export var ReplyType;
(function (ReplyType) {
    ReplyType["guess"] = "guess_question";
    ReplyType["consult"] = "consult_btn";
    ReplyType["retain"] = "retain_popup";
    ReplyType["reply"] = "quick_reply";
    ReplyType["search"] = "search_term";
})(ReplyType || (ReplyType = {}));
export var DEFAULT_AVATAR_IMAGE = '//leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/chart_server.svg';
